import { ReactNode } from "react";
import styles from "./PageContainer.module.css";

export type SectionSizes = {
  full: string;
  breakout: string;
  content: string;
};

const SectionContainer = ({
  ...props
}: {
  sectionSize: keyof SectionSizes;
  backgroundColor?: string | undefined;
  children: ReactNode;
}) => {
  const root = document.documentElement;
  root.style.setProperty(
    "--backgroundColour",
    props.backgroundColor ?? "white"
  );
  return (
    <section
      className={styles.PageContainer}
      style={{ backgroundColor: props.backgroundColor }}
    >
      <div className={styles[props.sectionSize]}>{props.children}</div>
    </section>
  );
};

export default SectionContainer;
